import { Avatar } from '../../../generated/graphql';

export interface AvatarOption {
  id: Avatar;
  name: string;
  thumbnailUrl: string;
  videoUrl: string;
}

export const AVATAR_OPTIONS: AvatarOption[] = [
  {
    id: Avatar.Spot,
    name: 'Spot',
    thumbnailUrl:
      'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/spot.png',
    videoUrl:
      'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/spot.mp4',
  },
  {
    id: Avatar.Avatar_1,
    // TEMPORARY (client demo): renamed from 'Claire' to match the new Anam avatar.
    // name: 'Claire',
    name: 'Perry',
    // thumbnailUrl:
    //   'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/claire.png',
    thumbnailUrl:
      'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/perry.jpeg',
    // No preview clip for Perry yet — an empty videoUrl makes the tile show the
    // still image only. Restore the Claire clip below when the demo is over.
    // videoUrl:
    //   'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/claire.mp4',
    videoUrl: '',
  },
  // TEMPORARY (client demo): only Spot and Avatar_1 are offered.
  // Uncomment Adrian and Meera once the demo is over.
  // {
  //   id: Avatar.Avatar_2,
  //   name: 'Adrian',
  //   thumbnailUrl:
  //     'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/adrian.png',
  //   videoUrl:
  //     'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/adrian.mp4',
  // },
  // {
  //   id: Avatar.Avatar_3,
  //   name: 'Meera',
  //   thumbnailUrl:
  //     'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/meera.png',
  //   videoUrl:
  //     'https://sz-production-ai-agent-avatars.s3.eu-west-2.amazonaws.com/meera.mp4',
  // },
];
